export const GENDER = [
  ['M', 'Male'],
  ['F', 'Female'],
];
export const RACE = [
  ['W', 'White'],
  ['B', 'Black'],
  ['A', 'Asian'],
  ['I', 'Native American'],
  ['U', 'Other'],
];
export const ETHNICITY = [
  ['H', 'Hispanic'],
  ['N', 'Non-Hispanic'],
];

export const PURPOSE_OF_STOP = [
  [1, 'Speed Limit Violation'],
  [2, 'Stop Light / Sign Violation'],
  [3, 'Driving While Impaired'],
  [4, 'Safe Movement Violation'],
  [5, 'Vehicle Equipment Violation'],
  [6, 'Vehicle Regulatory Violation'],
  [7, 'Seat Belt Violation'],
  [8, 'Investigation'],
  [9, 'Other Motor Vehicle Violation'],
  [0, 'Checkpoint'],
];
export const ACTION_TAKEN = [
  [1, 'Verbal Warning'],
  [2, 'Written Warning'],
  [3, 'Citation Issued'],
  [4, 'On-View Arrest'],
  [5, 'No Action Taken'],
];
